import React from "react";

function ContactPage() {
  return (
    <main className="relative min-h-screen bg-zinc-950 text-white overflow-hidden font-chivo">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-grid-pattern bg-[size:50px_50px] opacity-[0.08] pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-500/15 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-900/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3 pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-20">
        {/* Header */}
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="reveal inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs uppercase tracking-[0.2em] font-semibold mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-500 animate-pulse"></span>
            Get in Touch
          </div>
          <h1 className="reveal reveal-delay-1 font-chivo text-5xl md:text-7xl lg:text-8xl font-black leading-[0.95] tracking-tight">
            <span className="gradient-text">Contact</span>
          </h1>
        </div>

        {/* Two columns: info + map */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-14 items-start">
          {/* Left: contact cards */}
          <div className="flex flex-col gap-5">
            <a
              href="https://www.google.com/maps/place/BiniAutoRepairINC/@40.9515721,-73.8751458,15z/data=!4m2!3m1!1s0x0:0x58aeec725b7b64cb?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              rel="noreferrer"
              className="group flex items-start gap-5 p-6 md:p-7 rounded-3xl bg-white/[0.03] backdrop-blur-md border border-white/10 hover:border-brand-500/40 hover:bg-white/[0.06] transition-all"
            >
              <div className="w-14 h-14 flex-shrink-0 rounded-2xl bg-gradient-to-br from-brand-500 to-brand-800 flex items-center justify-center shadow-glow group-hover:scale-110 transition-transform">
                <i className="fa-solid fa-location-dot fa-lg text-white"></i>
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-1">
                  Address
                </div>
                <div className="font-montserrat text-lg">10 Eastman Pl</div>
                <div className="font-montserrat text-lg">Yonkers, NY 10701</div>
              </div>
              <i className="fa-solid fa-arrow-up-right-from-square text-zinc-500 group-hover:text-brand-400 ml-auto mt-2 transition-colors"></i>
            </a>

            <a
              href="tel:+13475820864"
              className="group flex items-start gap-5 p-6 md:p-7 rounded-3xl bg-white/[0.03] backdrop-blur-md border border-white/10 hover:border-brand-500/40 hover:bg-white/[0.06] transition-all"
            >
              <div className="w-14 h-14 flex-shrink-0 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-brand-500/50 transition-colors">
                <i className="fa-solid fa-phone fa-lg text-brand-400"></i>
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-1">
                  Phone
                </div>
                <div className="font-montserrat text-lg md:text-xl">
                  (347) 582-0864
                </div>
              </div>
              <i className="fa-solid fa-arrow-right text-zinc-500 group-hover:text-brand-400 group-hover:translate-x-1 ml-auto mt-3 transition-all"></i>
            </a>

            <a
              href="mailto:biniautorepairinc@gmail.com"
              className="group flex items-start gap-5 p-6 md:p-7 rounded-3xl bg-white/[0.03] backdrop-blur-md border border-white/10 hover:border-brand-500/40 hover:bg-white/[0.06] transition-all"
            >
              <div className="w-14 h-14 flex-shrink-0 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-brand-500/50 transition-colors">
                <i className="fa-solid fa-envelope fa-lg text-brand-400"></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-1">
                  Email
                </div>
                <div className="font-montserrat text-base md:text-lg break-all">
                  biniautorepairinc@gmail.com
                </div>
              </div>
              <i className="fa-solid fa-arrow-right text-zinc-500 group-hover:text-brand-400 group-hover:translate-x-1 ml-auto mt-3 transition-all flex-shrink-0"></i>
            </a>

            {/* Social */}
            <div className="p-6 md:p-7 rounded-3xl bg-white/[0.03] backdrop-blur-md border border-white/10">
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">
                Follow us
              </div>
              <div className="flex gap-3">
                <a
                  href="https://www.instagram.com/biniautorepairinc/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                  className="w-12 h-12 flex items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-zinc-300 hover:bg-gradient-to-br hover:from-brand-500 hover:to-brand-800 hover:text-white hover:border-transparent hover:scale-110 transition-all"
                >
                  <i className="fa-brands fa-instagram fa-xl"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@biniautorepair"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="TikTok"
                  className="w-12 h-12 flex items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-zinc-300 hover:bg-gradient-to-br hover:from-brand-500 hover:to-brand-800 hover:text-white hover:border-transparent hover:scale-110 transition-all"
                >
                  <i className="fa-brands fa-tiktok fa-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right: map */}
          <div className="md:sticky md:top-32">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px flex-1 bg-gradient-to-r from-transparent to-white/15"></span>
              <span className="text-xs uppercase tracking-[0.3em] text-zinc-400 font-semibold">
                Location
              </span>
              <span className="h-px flex-1 bg-gradient-to-l from-transparent to-white/15"></span>
            </div>
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-brand-900/30">
              <div className="absolute -inset-1 bg-gradient-to-br from-brand-500/40 to-transparent rounded-3xl blur-sm -z-10"></div>
              <iframe
                width="100%"
                height="600"
                frameBorder="0"
                title="map"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                className="grayscale-[30%] hover:grayscale-0 transition-all duration-500"
                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=BiniAutoRepairINC,%2010%20Eastman%20Pl,%20Yonkers,%20NY%2010701,%20United%20States+(Bini%20Autorepair%20INC)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              >
                <a href="https://www.gps.ie/">gps tracker sport</a>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ContactPage;
